const Partner = () => import('../views/Partner.vue')

export default [
  {
    path: 'partners',
    component: Partner,
    meta: { requiresAuth: true },
    name: 'partners'
  }
]